import React from "react";
import RequestWearables from "@/components/RequestWearables/RequestWearables";

const RequestWearablesPage: React.FC = () => {
  return <RequestWearables />;
};

export default RequestWearablesPage;
